export default function sleep(time = 1000): Promise<void> {
  return new Promise((res) => {
    setTimeout(res, time);
  });
}
